export default "__VITE_ASSET__B_hsQk4N__"